import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

const BasicTextField = withStyles(theme => ({
  root: {
    '& label.Mui-focused': {
      color: theme.palette.expressColors.strongYellow
    },
    '& label.Mui-error': {
      color: theme.palette.expressColors.red
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.expressColors.ligthYellow,
        borderWidth: 2
      }
    }
  }
}))(TextField);

const YellowTextField = props => {
  return <BasicTextField {...props} />;
};

export default YellowTextField;
